import * as qs from 'query-string';

import { routerActionCreators } from './state';

export const bindHistoryListener = history =>
  history.listen(newLocation => {
    if (newLocation) {
      newLocation.query = qs.parse(newLocation.search);

      routerActionCreators.locationChanged({
        location: newLocation
      });
    }
  });
